import React, { useState,useEffect } from 'react'
import { Container, Form, Row, Col, Button, Card } from "react-bootstrap";
import Select from "react-select";
import { useLocation,useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { postInputFlowList,getTypeDropdown,getProcessTypeDropdown,getDetailFlowType } from "../../../../../store/actions/cms/manageRP";
import Alert from "@mui/material/Alert";
import {clearPostInputFormListResponse,getDetailFlowTypeClearData}from "../../../../../store/slices/manageRP"
const AddEditFlowList = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate=useNavigate()
    const Type = location.state?.type;
    const id = location.state?.id;
    const [flowType, setFlowType] = useState("");
    const [type, setType] = useState();
    const [processType, setProcessType] = useState();
    const { postInputFormListData, postInputFormListError,typeData,processTypeData,detailFlowTypeData } =useSelector((state) => state.manageRP_Reducer);
    const { user } = useSelector((state) => state.userData);
    
    useEffect(() => {
        if(Type=="Input"){
            dispatch(getTypeDropdown({field_name:"input_type"}));
            dispatch(getProcessTypeDropdown({field_name:"input_process_type"}));
            if(id){
                dispatch(getDetailFlowType({detail_input_id:id}));
            }
        }
        if(Type=="Result"){
            dispatch(getTypeDropdown({field_name:"result_type"}));
            dispatch(getProcessTypeDropdown({field_name:"result_process_type"}));
            if(id){
                dispatch(getDetailFlowType({detail_result_id:id}));
            }
        }
      }, []);

      useEffect(() => {
        if(detailFlowTypeData && Type=="Input"){
            let type_data=typeData?.input_type?.find(
                (obj) => obj.value == detailFlowTypeData?.input_flow[0]?.input_type);
            let process_type_data=processTypeData?.input_process_type?.find(
                (obj) => obj.value == detailFlowTypeData?.input_flow[0]?.input_process_type)
            setFlowType(detailFlowTypeData?.input_flow[0]?.input_flow_type);
            setType(type_data);
            setProcessType(process_type_data);
        }
        if(detailFlowTypeData && Type=="Result"){
            let type_data=typeData?.result_type?.find(
                (obj) => obj.value == detailFlowTypeData?.result_flow[0]?.result_type);
            let process_type_data=processTypeData?.result_process_type?.find(
                (obj) => obj.value == detailFlowTypeData?.result_flow[0]?.result_process_type)
            setFlowType(detailFlowTypeData?.result_flow[0]?.result_flow_type);
            setType(type_data);
            setProcessType(process_type_data);
        }

        return () => {
            dispatch(getDetailFlowTypeClearData());
        }
      }, [detailFlowTypeData]);

    useEffect(() => {
        if (postInputFormListData) {
          setTimeout(() => {
            dispatch(clearPostInputFormListResponse());
            navigate('/cms/manage-rp/input-result-flow-type')
          }, 1000);
        }
        if (postInputFormListError) {
          setTimeout(() => {
            dispatch(clearPostInputFormListResponse());
          }, 4000);
        }
      }, [postInputFormListData || postInputFormListError]);

    const handleSave = () => {
        const dataType = Type.toLowerCase();
        let _type = `${dataType}_flow`;
        let data = {
            flow_type: _type,
            [`${dataType}_type`]: type?.value,
            [`${dataType}_flow_type`]: flowType,
            [`${dataType}_process_type`]: processType?.value,
            created_by : user?.data?.id,
            updated_by : user?.data?.id,
        };
        if (id) {
            data[`${dataType}_id`] = id; // Add id if it exists
        }
        dispatch(postInputFlowList(data));
    }
    
    return (
        <Container fluid className="p-4">
             <div className={"notification_popup"}>
        {(postInputFormListData || postInputFormListError) && (
          <Alert severity={postInputFormListError ? `error` : `success`}>
            {" "}
            {postInputFormListData?"Data Added Successfully" : `${postInputFormListError?.data}`}
          </Alert>
        )}
      </div>
            <h4 className="news_letter_heading">Adding and Editing {Type} Flow Types</h4>
            {/* ***************breadcrumb****************** */}
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="/cms">Home</a>
                    </li>
                    <li className="breadcrumb-item active">
                        <a href="/cms/manage-rp/input-result-flow-type">Input and Result Flow Types</a>
                    </li>
                    <li className="breadcrumb-item">Add/Edit</li>
                </ol>
            </nav>
            <Card className="mb-4">
                <Card.Body>
                    <h3>{id ? "Edit" : "Add"} RP {Type} Flow Type</h3>
                    <Row className="g-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Enter {Type} Flow Type</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={flowType}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (input.length <= 30) {
                                        setFlowType(input);
                                        }
                                    }}
                                    />
                                    {postInputFormListError?.data && <div className='error'>{Type} Flow Type {postInputFormListError?.data} </div>}
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Enter {Type} Type</Form.Label>
                                <Select
                                    isClearable
                                    isSearchable
                                    options={Type=="Input" ? typeData?.input_type : typeData?.result_type  }
                                    onChange={(obj) => setType(obj)}
                                    value={type}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Enter {Type} Process Type</Form.Label>
                                <Select
                                    isClearable
                                    isSearchable
                                    options={Type=="Input" ? processTypeData?.input_process_type:processTypeData?.result_process_type}
                                    onChange={(obj) => setProcessType(obj)}
                                    value={processType}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Button variant="primary" className='px-4' onClick={handleSave}>Save</Button>
        </Container>
    )
}

export default AddEditFlowList
